export default __webpack_public_path__ + "static/media/kazeem.0004ad49.jpeg";